import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

i18n.services.logger = {
  log: () => {},
  warn: () => {},
  error: () => {},
}

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Bind react-i18next
  .init({
    fallbackLng: "en",
    debug: false, // ✅ Turn off debug mode before production
    saveMissing: false,
    supportedLngs: ["en", "he"],
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          /* ... */
        },
      },
      he: {
        translation: {
          Help: "עזרה",
          Skill: "כישרון",
          Skills: "כישרונות",
          Rating: "דירוג",
          Unlimited: "ללא הגבלה",
          Prefrences: "העדפות",
          Filter: "מסנן",
          "Learn with AI": "AI למד עם",
          "Cost Per User": "עלות למשתמש",
          Cost: "עלות",
          Location: "מיקום",
          Duration: "משך",
          Description: "תיאור",
          Participants: "משתתפים",
          Status: "סטטוס",
          "Choose your package and securely complete your purchase with your credit card":
            "בחר את החבילה שלך ושלם בביטחון עם כרטיס אשראי",
          "Select a Credit Package": "בחר חבילה",
          Credit: "קרדיט",
          Credits: "קרדיט",
          "Enter Your Payment Details": "הזן את פרטי התשלום שלך",
          "Cardholder ID": "תעודת זהות בעל הכרטיס",
          "Credit Card Number": "מספר כרטיס אשראי",
          "Expiration Date": "תאריך תפוגה",
          CVV: "קוד אבטחה",
          "Secure payment with 256-bit encryption": "תשלום מאובטח עם הצפנה של 256 סיביות",
          "Buy Credits": "קנה קרדיט",
          Address: "כתובת",
          Country: "מדינה",
          City: "עיר",
          "Phone Number": "מספר טלפון",
          "Contact Email": "כתובת דואר אלקטרוני",
          "Website URL": "כתובת אתר",
          CRN: "מספר רישוי",
          paid: "שולם",
          "Unlock Unlimited Growth": "פתח צמיחה בלתי מוגבלת",
          "Join our business package and gain access to limitless possibilities. Empower your team with unlimited credits, skills, and users. Let your business soar.":
            "הצטרף לחבילת העסקים שלנו וקבל גישה לאפשרויות בלתי מוגבלות. העצם את הצוות שלך עם קרדיטים, כישרונות ומשתמשים ללא הגבלה. תן לעסק שלך להמריא.",
          "Get Started Now": "התחל עכשיו",
          "Business Package Benefits": "יתרונות חבילת העסקים",
          "Unlimited Credits": "קרדיטים ללא הגבלה",
          "Unlimited Skills": "כישרונות ללא הגבלה",
          "Premium Support": "תמיכה פרימיום",
          "Receive 24/7 priority support for all your needs.":
            "קבל תמיכה עדיפות 24/7 לכל הצרכים שלך.",
          "Find as many top rated users as you need.": "מצא כמה שיותר משתמשים מדורגים שאתה צריך.",
          "Equip your team with an ever-growing set of skills.":
            "הכנס את הצוות שלך עם סט כישורים הולך וגדל.",
          "Never worry about credit limits your growth is unlimited.":
            "אל תדאג מגבולות האשראי שלך, הצמיחה שלך היא בלתי מוגבלת.",
          "Ready to Take Your Business to the Next Level?": "מוכן לקחת את העסק שלך לשלב הבא?",
          Purchases: "רכישות",
          "Your Statistics": "הסטטיסטיקות שלך",
          Views: "צפיות",
          Likes: "לייקים",
          Favorites: "מועדפים",
          "Most Liked Skill": "הכישרון הכי אהוב",
          "Most Viewed Skill": "הכישרון הכי נצפה",
          "view skill": "צפייה בכישרון",
          like: "אהבתי",
          "buy skill": "קניתי כישרון",
          "view profile": "צפייה בפרופיל",
          "joined group": "הצטרפתי לקבוצה",
          "rated skill": "דירוג הכישרון",
          search: "חיפוש",
          Search: "חיפוש",
          "Not Seen": "לא נצפה",
          Seen: "נצפה",
          "Recent Activity": "פעילות אחרונה",
          "You received a": "קיבלת",
          "notification from": "מ",
          "My Groups": "הקבוצות שלי",
          "Groups I'm in": "קבוצות שבהן אני רשום",
          "You haven't joined any groups yet": "טרם נרשמת לקבוצות",
          "All Groups": "כל הקבוצות",
          open: "פתוח",
          closed: "סגור",
          "No groups found": "לא נמצאו קבוצות",
          "Create New Group": "צור קבוצה חדשה",
          User: "משתמש",
          Messages: "הודעות",
          "Top Rated Users": "משתמשים מובילים",
          "Top Rated Skills": "כישרונות מובילים",
          "Favorite Skills": "כישרונות שאהבתי",
          "No similar skills found": "לא נמצאו כישרונות דומים",
          "Loading similar skills": "טוען כישרונות דומים",
          "Search for a similar skill": "חפש כישרונות דומים",
          "Post A Skill ...": "פרסם/י את הכישרון שלך ...",
          "People Like Me": "אנשים כמוני",
          Support: "תמיכה",
          "Start A Post": "התחל לשתף",
          "View Skill": "צפה בזה",
          "Learning This": "לומדים כרגע",
          Like: "אהבתי",
          "Reset Filter": "נקה מסנן",
          Chat: "שוחח",
          "Buy Skill": "קנה",
          Share: "שתף",
          Reviews: "ביקורות",
          Group: "קבוצה",
          "View Profile": "צפה בפרופיל",
          Home: "בית",
          Orders: "הזמנות",
          Groups: "קבוצות",
          Notifications: "עדכונים",
          "Buy Credit": "קנה קרדיט",
          "For Business": "לעסקים",
          Account: "חשבון",
          Profile: "פרופיל",
          Activity: "פעילות",
          Logout: "התנתקות",
          Rate: "דרג",
          "Mark Finished": "סמן/י סיום",
          "Outgoing Order": "הזמנה יוצאת",
          "Incoming Order": "הזמנה נכנסת",
          "Open Edit": "פתח עריכה",
          "Close Edit": "סגור עריכה",
          "This is Beta version! Let us know if you have any suggestions by clicking on help in your profile.":
            ".זאת גרסת בטא! שתפו אותנו בכל הצעה או בעיה  על ידי לחיצה על כפתור עזרה בפרופיל",
          "Edit Profile": "עריכת פרופיל",
          Login: "התחבר/י",
          "Remember Me": "זכור אותי",
          "Forgot Password": "שכחתי סיסמה",
          "don't have an account yet? Click me": "עדיין אין לך חשבון? לחץ כאן",
          "User Name": "שם משתמש",
          Password: "סיסמה",
          "back to main page": "חזרה לדף הראשי",
          Signup: "הירשם/י",
          Confirm: "אשר",
          "No One Is Learning This Yet": "!היה הראשון ללמוד את זה",
          "Skill Cost (in credits)": "מחיר כישרון(בקרדיט)",
          "Chat with AI": "שוחח עם AI ",
          "Type your message...": "הקלד הודעה...",
          Send: "שלח",
          "Start Date": "תאריך התחלה",
          "Have An Idea Or Issue ?": "יש לך רעיון? נתקלת בבעיה?",
          "Your Email": "דואר אלקטרוני",
          "Send Us A Message": "שלח לנו הודעה",
          "Send Email": "שלח",
          Message: "הודעה",
          "Skill Name": "שם הכישרון",
          "No Reviews Found!": "לא נמצאו דירוגים",
          "Get Support / Report an Issue": "פתח נושא/בקש תמיכה",
          Subject: "נושא",
          "Are You Sure?": "האם אתה בטוח?",
          "Are you sure you want to delete this group? This action cannot be undone":
            "האם אתה בטוח שאתה רוצה למחוק את הקבוצה הזאת? פעולה זו הינה בלתי הפיכה",
          Cancel: "ביטול",
          Delete: "מחיקה",
          "Max Participants": "מספר משתמשים מקסימלי",
          "Group Name": "שם קבוצה",
          "Loading content...": "טוען תוכן...",
          "Create Link": "צור קישור",
          Save: "שמור",
          "Post Skill": "פרסם כישרון",
          "Save Post": "שמור כישרון",
          "Links Map": "מפת קישורים",
          Me: "אני",
          "Choose File": "בחר קובץ",
          Buycredit: "רכישה",
          Businesspage: "לעסקים",
          "No notifications available": "אין עדכונים זמינים",
          "Search Business": "חיפוש עסקים",
          "Search Users": "חיפוש משתמשים",
          "Company Business Information": "פרטי עסק/חברה",
          "Please fill in the details below to help us know more about your company":
            "אנא מלא את הפרטים למטה כדי שנוכל להכיר את העסק שלך",
          "Company Name": "שם חברה",
          "Company Description": "תיאור חברה",
          "This action is irreversible. Please confirm your choice":
            "פעולה זו הינה בלתי הפיכה, אנא אשר את בחירתך",
          "Remove Link": "הסר קישור",
          "Saved Skills": "כישרונות שמורים",
          "Enter Your Details": "הכנס פרטים",
          "Full Name": "שם מלא",
          Email: "דואר אלקטרוני",
          "Search for groups": "חיפוש קבוצות",
          "Fun Facts About": "עובדות מעניינות על",
          "Invalid Character": "תו לא חוקי",
          "What People Are Saying About Sharie": "מה אנשים אומרים על Sharie",
          "Add Testamony": "הוסף המלצות",
          "Share Your Experience": "שתף את החוויה שלך",
          "We'd love to hear what you think about Sharie!": "נשמח לשמוע מה אתה חושב על Sharie!",
          "Your Message": "ההודעה שלך",
          "Submit Testamony": "שלח המלצה",
          "100% Secure Payment": "תשלום מאובטח ב-100% עם הצפנה של 256 סיביות",
          "Your payment is encrypted and protected with SSL security.":
            "התשלום שלך מוצפן ומוגן עם אבטחת SSL.",
          "Transparent Pricing": "מחירים שקופים",
          "No hidden fees. What you see is what you pay.":
            "אין עמלות נסתרות. מה שאתה רואה זה מה שאתה משלם.",
          "Privacy Protected": "פרטיות מוגנת",
          "Your personal information is never shared.": "המידע האישי שלך לא משותף אף פעם.",
          "Trusted by Thousands": "מאומת על ידי אלפי משתמשים",
          "Join over": " הצטרף ליותר מ-",
          "happy users worldwide.": "משתמשים מרוצים ברחבי העולם.",
          Time: "זמן",
          From: "מאת",
          To: "אל",
          Discover: "גלה עוד",
          Connect: "התחבר",
          "Join Now": "הצטרף עכשיו",
          "Skills. Shared. Elevated.": "כישרונות. משותפים. משופרים.",
          "Share talent. Unlock growth.": "שתף כישרונות. התחל לצמוח.",
          "Find collaborators.": "מצא שותפים.",
          "Discover skilled people and learn": "גלה אנשים מוכשרים ולמד",
          "what matches your interests.": "מה שמתאים לתחומי העניין שלך.",
          "Showcase talents.": "הצג כישרונות.",
          "Share your unique skills and": "שתף את הכישרונות הייחודיים שלך",
          "portfolio to attract new": "ותיק עבודות כדי למשוך הזדמנויות",
          "opportunities.": "חדשות.",
          "Grow together.": "צמחו יחד.",
          "Build a supportive network that": "בנה רשת תומכת שעוזרת",
          "helps you and others thrive.": " לך ולאחרים לשגשג.",
          "Sharie®": "®Sharie",
          "Combined Skills": "כישרונות משולבים",
          "Post Demand": "פרסם ביקוש",
          Demand: "ביקוש",
          Feedback: "משוב",
          "What did you like about Sharie?": "מה אהבת ב-Sharie?",
          "Did you dislike anything?": "האם לא אהבת משהו?",
          "What made you stay?": "מה גרם לך להישאר?",
          "Did anything make you leave, why?": "האם משהו גרם לך לעזוב, מדוע?",
          "How easy was it to use Sharie?": "כמה קל היה להשתמש ב-Sharie?",
          "Would you recommend Sharie to a friend?": "האם תמליץ על Sharie לחבר?",
          "What was the most useful section for you?": "מה היה החלק הכי שימושי עבורך?",
          "What features would you like us to add?": "אילו תכונות תרצה שנוסיף?",
          "How was your overall experience?": "איך הייתה החוויה הכללית שלך?",
          "Contact info (if you'd like us to reach out)":
            "פרטי יצירת קשר (אם תרצה שניצור איתך קשר)",
          "Submit Feedback": "שלח משוב",
          "Very difficult": "מאוד קשה",
          Difficult: "קשה",
          Okay: "בסדר",
          Easy: "קל",
          "Very easy": "מאוד קל",
          Yes: "כן",
          Maybe: "אולי",
          No: "לא",
          "We would appreciate your opinion to improve Sharie!":
            "נשמח לקבל את דעתך כדי לשפר את Sharie!",
          "We would love to hear your opinion or ideas!": "נשמח לשמוע את דעתך או רעיונותיך!",
          Content: "תוכן",
          Design: "עיצוב",
          Community: "קהילה",
          Other: "אחר",
          Bugs: "באגים",
          Confusing: "מבלבל",
          "Valuable content": "תוכן בעל ערך",
          "Easy to use": "קל לשימוש",
          Fun: "כיף",
          "More skills": "יותר כישרונות",
          "Better chat": "צ'אט טוב יותר",
          "More Groups": "יותר קבוצות",
          Nothing: "כלום",
          "Not enough value": "לא מספיק ערך",
          "Skill search": "חיפוש כישרונות",
          "Posts and content": "פוסטים ותוכן",
          Messaging: "הודעות ותקשורת",
          "Other sections": "חלקים אחרים",
          Posts: "פוסטים",
          Bad: "רע",
          Good: "טוב",
          Excellent: "מצוין",
          "Thank you for your feedback!": "תודה על המשוב שלך!",
          "Edit Business Card": "ערוך כרטיס ביקור",
          Marketplace: "מרקט",
          Business: "עסקים",
          "Search items...": "חפש פריטים...",
          New: "חדש",
          Used: "משומש",
          Refurbished: "משופץ",
          "Add New Item": "הוסף פריט חדש",
          Title: "כותרת",
          Price: "מחיר",
          "Add Item": "הוסף פריט",
          "No skills or groups found.": "לא נמצאו כישרונות או קבוצות.",
          "Here you can find your skills and groups. go ahead and create your first one!":
            "כאן תוכל למצוא את הכישרונות והקבוצות שלך. קדימה, צור את הראשון שלך!",
          "Take A Suvrey": "מלא סקר",
          "Enter location": "הזן מיקום",
          "Enter skill name": "הזן שם כישרון",
          "Enter user name": "הזן שם משתמש",
          "Who am I?": "מי אני?",
          "Add Group": "הוסף קבוצה",
          Name: "שם",
          "Close Menu": "סגור תפריט",
          "Open Menu": "פתח תפריט",
          "My Island": "האי שלי",
          "Get Tips": "קבל טיפים",
          "Restore Icons": "שחזר סמלים",
          orders: "הזמנות",
          groups: "קבוצות",
          profile: "פרופיל",
          activity: "פעילות",
          logout: "התנתק",
          business: "עסקים",
          skills: "כישרונות",
          "Daily Wisdom": "משפט חוכמה יומי",
          "Post Reflection": "פרסם מחשבותיך",
          "Reflect Now": "הוסף עכשיו",
          "Reflect on Today's Wisdom": "הרהר בחוכמה של היום",
          "What does this mean to you today?": "מה זה אומר לך היום?",
          "No similar users found.": "לא נמצאו משתמשים דומים.",
          Level: "רמת קושי",
          beginner: "מתחיל",
          advanced: "מתקדם",
          expert: "מומחה",
          Beginner: "מתחיל",
          Advanced: "מתקדם",
          Expert: "מומחה",
          Refundable: "ניתן להחזר",
          "Not Refundable": "לא ניתן להחזר",
          Refund: "החזר",
          "Payment Method": "שיטת תשלום",
          "Give Away": "למסירה",
          ILS: "שקל חדש",
          "Transfer credit": "העבר קרדיט",
          "Exact user name": "שם משתמש מדויק",
          "Click here to share your talent": "לחץ כאן כדי לשתף את הכישרון שלך",
          "It will be added to the feed of all talents": "הוא יתווסף לפיד הכללי של כל הכישרונות",
          "Check your Island with all your stuff": "בדוק את האי שלך עם כל הדברים שהם רק שלך",
          "This Sphere is AI powered": "הספירה מסמלת פעולה עם בינה מלאכותית",
          "Offensive language detected!": "נתגלתה שפה פוגענית!",
          "Upload Image/Video": "תמונה/וידאו",
          Reflection: "מחשבות",
          "Skill Level": "רמת כישרון",
          "Visit Website": "בקר באתר",
          "Find business to co-op with": "מצא עסקים לשיתוף פעולה",
          Users: "משתמשים",
          "Find users in your organization": "מצא משתמשים בארגון שלך",
          "No users found": "לא נמצאו משתמשים",
          "Search Skills": "חפש כישרונות",
          "Filter skills by multiple criteria and find users":
            "סנן כישרונות לפי קריטריונים מרובים ומצא משתמשים",
          Clear: "נקה",
          "Demand Analytics": "ניתוח ביקוש",
          "Total Demands": "סך הביקושים",
          "Average Likes": "ממוצע לייקים",
          "Average Views": "ממוצע צפיות",
          "Top Demands": "ביקושים מובילים",
          "Demands by User": "ביקושים לפי משתמש",
          "Top Demands (Likes / Views)": "ביקושים מובילים (לייקים / צפיות)",
          "Search by user or text": "חפש לפי משתמש או טקסט",
          "No demands found": "לא נמצאו ביקושים",
          Engagement: "מעורבות",
          "Demands Timeline": "ביקוש לפי זמן",
          "We’re here to help with any problem or feedback": "אנחנו כאן כדי לעזור בכל בעיה או משוב",
          "You have no groups yet.": "טרם יצרת קבוצות.",
          Conversations: "שיחות",
          "No conversations yet.": "טרם נוצרו שיחות.",
          "Start by sending a message to a user.": "התחל/י על ידי שליחת הודעה למשתמש.",
          "Online recently": "מחובר לאחרונה",
          "Choose a conversation to start chatting": "בחר/י שיחה כדי להתחיל לשוחח",
          "No messages yet. Say hi": "טרם נשלחו הודעות. שלח/י הודעה",
          "Pick a user from the left to start a conversation.":
            "בחר/י משתמש משמאל כדי להתחיל שיחה.",
          "Tap to open": "לחץ/י כדי לפתוח",
          Open: "פתח",
          "Type a message…": "הקלד/י הודעה…",
          "Select a conversation first": "בחר/י שיחה קודם",
          "Select a conversation": "בחר/י שיחה",
          Demands: "ביקושים",
          "Join Group": "הצטרף לקבוצה",
          "Must Fill All Fields": "חובה למלא את כל השדות",
          "User Name must be 3-15 characters long and can only contain letters, numbers, and underscores.":
            "שם המשתמש חייב להיות באורך של 3-15 תווים ויכול להכיל רק אותיות, מספרים וקווים תחתונים.",
          "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.":
            "הסיסמה חייבת להיות באורך של לפחות 8 תווים ולכלול אותיות גדולות, אותיות קטנות, מספר ותו מיוחד.",
          "Password must be a combination of uppercase, lowercase, number, and special character.6 characters minimum.":
            "הסיסמה חייבת להיות שילוב של אותיות גדולות, אותיות קטנות, מספר ותו מיוחד. מינימום 6 תווים.",
        },
      },
    },
  })

export default i18n
